import { useState, useEffect, useRef, useMemo } from "react";
import {
  Box,
  Typography,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Autocomplete,
  TextField,
  CircularProgress,
  Stack,
  Tooltip,
  Fade,
} from "@mui/material";
import Loader from "../common/Loader";

export default function DocumentControl() {
  // SO-related states commented
  /*
  const [soData, setSOData] = useState([]);
  const [loadingSO, setLoadingSO] = useState(false);
  const [loading, setLoading] = useState(true);
  const [searchTermso, setSearchTermso] = useState("");
  const [selectedSO, setSelectedSO] = useState(null);
  const [message, setMessage] = useState(null);
  const [showTooltip, setShowTooltip] = useState(false);
  const autocompleteRef = useRef(null);
  const tooltipTimeoutRef = useRef(null);
  */

  // SO data fetching and effect commented
  /*
  useEffect(() => {
    const loadSOData = async () => {
      setLoadingSO(true);
      try {
        const data = await fetchSONames();
        setSOData(data);
      } catch (error) {
        console.error("Error loading SO data:", error);
      } finally {
        setLoadingSO(false);
        setLoading(false);
      }
    };

    loadSOData();
  }, []);
  */

  // SO tooltip timeout cleanup commented
  /*
  useEffect(() => {
    return () => {
      if (tooltipTimeoutRef.current) {
        clearTimeout(tooltipTimeoutRef.current);
      }
    };
  }, []);
  */

  // SO filter memo commented
  /*
  const filteredSOData = useMemo(() => {
    return filterSOsBySearchTerm(soData, searchTermso);
  }, [soData, searchTermso]);
  */

  // SO selection handler commented
  /*
  const handleSOSelection = (event, value) => {
    setSelectedSO(value);

    // Clear any existing tooltip timeout
    if (tooltipTimeoutRef.current) {
      clearTimeout(tooltipTimeoutRef.current);
    }

    if (value) {
      // Just log the essential data we need
      console.log("Selected SO Name:", value.name);
      console.log("Selected SO ID:", value.id);
      console.log("Selected SO Number:", value.number);

      //Show tooltip for 15 seconds
      setShowTooltip(true);
      tooltipTimeoutRef.current = setTimeout(() => {
        setShowTooltip(false);
      }, 15000);
    } else {
      setMessage(null);
      setShowTooltip(false);
    }
  };
  */

  // SO record creation handler commented
  /*
  const handleCreateRecord = () => {
    if (!selectedSO) {
      setMessage({
        type: "error",
        text: "Please select a Sales Order first",
      });
      return;
    }

    // Only use the ID and name for record creation
    const soId = selectedSO.id;
    const soName = selectedSO.name;
    console.log("Creating record with SO ID:", soId);
    console.log("SO Name:", soName);
    setMessage({
      type: "info",
      text: `Processing: ID=${soId}, Name=${soName}`,
    });
    // Simulate API call
    setTimeout(() => {
      setMessage({
        type: "success",
        text: `Record created with SO ID: ${soId}`,
      });
    }, 1000);
  };
  */

  // SO option label function commented
  /*
  const getOptionLabel = (option) => {
    // For dropdown options, show full details
    if (option && option.name) {
      return option.name; // Only show name for the selected value in input field
    }
    return "";
  };
  */

  //above code is for SO name
  return (
    <Box p={3}>
      <Typography
        variant="h4"
        fontWeight="bold"
        mb={3}
        sx={{ color: "#4F46E5" }}
      >
        Document Control
      </Typography>
      {/* SO Autocomplete and Tooltip commented
      <Tooltip
        fullWidth
        size="small"
        open={showTooltip && selectedSO !== null}
        placement="top-start"
        arrow
        TransitionComponent={Fade}
        TransitionProps={{ timeout: 600 }}
        disableFocusListener
        disableHoverListener
        disableTouchListener
      >
        <Autocomplete
          sx={{
            // Input text color - always black
            "& .MuiInputBase-input": {
              color: "#000000", // Black text color
            },
            // Border styling
            "& .MuiOutlinedInput-root": {
              // Default state - light gray
              "& fieldset": {
                borderColor: "#d3d3d3", // Light gray as default
              },
              // Focus state
              "&.Mui-focused fieldset": {
                borderColor: "#4F46E5", // Keep consistent with your desired color
              },
            },
            // Label color
            "& .MuiInputLabel-root.Mui-focused": {
              color: "#4F46E5", // Changes label color to match when focused
            },
          }}
          ref={autocompleteRef}
          id="so-search"
          options={filteredSOData}
          getOptionLabel={getOptionLabel}
          // For searching, still use the full string with number and account
          filterOptions={(options, state) => {
            return filterSOsBySearchTerm(options, state.inputValue);
          }}
          // Only show name when selected in the input field
          renderInput={(params) => (
            <TextField
              {...params}
              label="Search Job name From SO"
              variant="outlined"
              fullWidth
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {loadingSO ? (
                      <CircularProgress color="inherit" size={10} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          )}
          // Control what appears in the dropdown menu during search
          renderOption={(props, option) => (
            <li {...props}>
              <Stack direction="column" spacing={0.5}>
                <Stack direction="row" spacing={1} alignItems="center">
                  <Typography variant="body1" fontWeight="bold">
                    {option.number}
                  </Typography>
                </Stack>
                <Typography variant="body2">Job Name: {option.name}</Typography>
              </Stack>
            </li>
          )}
          loading={loadingSO}
          value={selectedSO}
          onChange={handleSOSelection}
          onInputChange={(event, newInputValue) => {
            setSearchTermso(newInputValue);
          }}
        />
      </Tooltip>
      */}
    </Box>
  );
}
